import React from 'react';
import {
	AreasOfExpertise,
	CooperationModels,
	ServicesHeader,
} from './components';

export const ServicesContainer: React.FC = () => {
	return (
		<>
			<ServicesHeader />
			<AreasOfExpertise />
			<CooperationModels />
		</>
	);
};
